class Infrastructure {

    constructor() {
        this.init();
    }

    init() {
        this.$container = $('.js-infrastructure');
        if (this.$container.length === 0) {
            return;
        }
        this.$map = this.$container.find('.js-map');
        this.centerCoords = this.$map.data('center').split(',');
        this.path = this.$map.data('path');
        if (this.$map.length) {
            this.loadMap();
        }
        this.map = null;

        this.$placeTitle = this.$container.find('.js-place-title');
        this.$placeDesc = this.$container.find('.js-place-desc');

        this.defaultTitle = this.$placeTitle.html();
        this.defaultDesc = this.$placeDesc.html();
    }

    loadMap() {
        $('<script src="//api-maps.yandex.ru/2.1/?lang=ru_RU" type="text/javascript"></script>').appendTo('body');
        const mapLoader = setInterval(() => {
            if (typeof(ymaps) === 'object' && typeof(ymaps.Map) === 'function') {
                ymaps.ready(() => {
                    this.initMap();
                });
                clearInterval(mapLoader);
            }
        }, 100);
    }

    initMap() {
        this.map = new ymaps.Map(this.$map.get(0), {
            center: this.centerCoords,
            zoom: 15,
            controls: []
        }, {
            searchControlProvider: 'yandex#search'
        });

        this.map.behaviors.disable('scrollZoom');

        this.initMapControls();
        this.addPoints();
    }

    initMapControls() {
        const $map = this.$map;
        const ZoomLayout = ymaps.templateLayoutFactory.createClass(
            '<div class="map-box__zoomBox">' +
            '<button type="button" class="map__icon js-map-zoom-in">' +
            '<svg><use xlink:href="#spr-plus" /></svg>' +
            '</button>' +
            '<button type="button" class="map__icon js-map-zoom-out">' +
            '<svg><use xlink:href="#spr-minus" /></svg>' +
            '</button>' +
            '</div>', {
                    build: function () {
                        ZoomLayout.superclass.build.call(this);
                        this.zoomInCallback = ymaps.util.bind(this.zoomIn, this);
                        this.zoomOutCallback = ymaps.util.bind(this.zoomOut, this);
                        $map.find('.js-map-zoom-in').bind('click touchend', this.zoomInCallback);
                        $map.find('.js-map-zoom-out').bind('click touchend', this.zoomOutCallback);
                    },
                    clear: function () {
                        $map.find('.js-map-zoom-in').unbind('click touchend', this.zoomInCallback);
                        $map.find('.js-map-zoom-out').unbind('click touchend', this.zoomOutCallback);
                        ZoomLayout.superclass.clear.call(this);
                    },
                    zoomIn: function () {
                        const map = this.getData().control.getMap();
                        map.setZoom(map.getZoom() + 1, {checkZoomRange: true});
                    },
                    zoomOut: function () {
                        const map = this.getData().control.getMap();
                        map.setZoom(map.getZoom() - 1, {checkZoomRange: true});
                    }
                }),
            zoomControl = new ymaps.control.ZoomControl({options: {layout: ZoomLayout}});
        this.map.controls.add(zoomControl);
    }

    addPoints() {
        $.ajax({
            type: "GET",
            url: this.$map.data('points'),
            dataType: 'json',
            data: '',
            success: (points) => {
                this.setPoints(points);
            }
        });
    }

    setPoints(points) {
        this.setDefaultInfo();

        for (let i = 0; i < points.length; i++) {

            let layout;
            if (points[i].type === 'metro') {
                layout = ymaps.templateLayoutFactory.createClass(`
                <div class="map__placemark map__placemark_metro"  data-index="${i}">
                    <div class="map__placemark__metro-letter">
                        М
                    </div>
                </div>`);
            } else {
                layout = ymaps.templateLayoutFactory.createClass(`
                    <div class="map__placemark" data-index="${i}">
                        <svg class="map__placemark__body"><use xlink:href="#spr-marker" /></svg>
                        <svg class="map__placemark__shadow"><use xlink:href="#spr-marker-shadow" /></svg>
                        <svg class="map__placemark__icon map__placemark__icon_${points[i].type}"><use xlink:href="#spr-marker-icon-${points[i].type}" /></svg>
                    </div>`);
            }
            const placemark = new ymaps.Placemark(
                points[i].coordinates.split(','), {},
                {
                    iconLayout: layout,
                    iconShape: {
                        type: 'Rectangle',
                        // Прямоугольник описывается в виде двух точек - верхней левой и нижней правой.
                        coordinates: [
                            [-25, -25], [25, 25]
                        ]
                    }
                }
            );
            this.map.geoObjects.add(placemark);

            placemark.events.add('mouseenter', () => {
                $(`.map__placemark[data-index="${i}"]`).addClass('map__placemark_hover');
            });
            placemark.events.add('mouseleave', () => {
                $(`.map__placemark[data-index="${i}"]`).removeClass('map__placemark_hover');
            });
            placemark.events.add('click', () => {
                $(`.map__placemark`).removeClass('map__placemark_active');
                $(`.map__placemark[data-index="${i}"]`).addClass('map__placemark_active');
                const title = points[i].title,
                    text = points[i].text;
                this.setObjectInfo(title, text);
            });
        }
    }

    setObjectInfo(title, text) {
        this.$placeTitle.html(title);
        this.$placeDesc.html(text);
    }

    setDefaultInfo() {
        this.$placeTitle.html(this.defaultTitle);
        this.$placeDesc.html(this.defaultDesc);
    }
}



export default new Infrastructure();



// WEBPACK FOOTER //
// ./js/infrastructure.js